import { render, staticRenderFns } from "./pedidorInformacionGeneralExp.vue?vue&type=template&id=9e80c9fa"
import script from "./pedidorInformacionGeneralExp.vue?vue&type=script&lang=js"
export * from "./pedidorInformacionGeneralExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports